import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'sidebar',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      backgroundColor: theme.palette.primary.main,
      border: 'none',
    },
    drawer: {},
    drawerPaper: {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.primary.contrastText,
      border: 'none',
    },
    toolbar: {
      padding: theme.spacing(1.25, 2.5),
    },
    nav: {
      // padding: 0
    },
    navItem: {
      padding: theme.spacing(1.5, 2.5),
      '&$navItemSelected, &$navItemSelected:hover, &:hover': {
        backgroundColor: theme.palette.light[200],
      },
    },
    navItemSelected: {},
    navItemIcon: {
      color: 'inherit',
      opacity: 0.4,
      fill: 'none',
      marginRight: theme.spacing(1),
    },
    navItemLabel: {
      // margin: 0,
    },
  }),
  options
);

export default useStyles;
